import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { chatId: Number, text: String }

  sendReply(event) {
    event.preventDefault()
    
    const text = event.currentTarget.dataset.replyShortcutsTextValue
    const form = document.getElementById("new_message")
    const textarea = form.querySelector("textarea[name='message[content]']")
    
    // Fill the form with the shortcut text
    textarea.value = text
    
    // Remove all shortcuts immediately
    this.element.innerHTML = ""
    
    // Submit the form
    form.requestSubmit()
  }
}